import {
  ProductStaPriceCreateBody,
  ProductStaPriceDetailResponse,
  ProductStaPriceItem,
  ProductStaPriceListResponse,
} from "../types"

export class ProductStaPrice {
  private client: unknown

  constructor(client: unknown) {
    this.client = client
  }

  // import(body: { file: File }, query?: Record<string, any>, headers?: Record<string, any>): Promise<any> {
  //   return (async () => {
  //     const form = new FormData();
  //     form.append("file", body.file);
  //     return await this.client.fetch(`/admin/products/import`, {
  //       method: "POST",
  //       headers: {
  //         ...headers,
  //         "content-type": null,
  //       },
  //       body: form,
  //       query,
  //     });
  //   })();
  // }

  // confirmImport(transactionId: string, query?: Record<string, any>, headers?: Record<string, any>): Promise<any> {
  //   return (async () => {
  //     return await this.client.fetch(`/admin/products/import/${transactionId}/confirm`, {
  //       method: "POST",
  //       headers,
  //       body: {},
  //       query,
  //     });
  //   })();
  // }

  // export(body: Record<string, any>, query?: Record<string, any>, headers?: Record<string, any>): Promise<any> {
  //   return (async () => {
  //     return await this.client.fetch(`/admin/products/export`, {
  //       method: "POST",
  //       headers,
  //       body,
  //       query,
  //     });
  //   })();
  // }

  // batch(body: Record<string, any>, query?: Record<string, any>, headers?: Record<string, any>): Promise<any> {
  //   return (async () => {
  //     return await this.client.fetch(`/admin/products/batch`, {
  //       method: "POST",
  //       headers,
  //       body,
  //       query,
  //     });
  //   })();
  // }

  create(
    vendorId: string,
    productId: string,
    body: ProductStaPriceCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<ProductStaPriceItem> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/products/${productId}/sta-price`,
        {
          method: "POST",
          headers,
          body,
          query,
        }
      )
    })()
  }

  update(
    id: string,
    vendorId: string,
    productId: string,
    body: ProductStaPriceCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<ProductStaPriceItem> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/products/${productId}/sta-price/${id}`,
        {
          method: "PUT",
          headers,
          body,
          query,
        }
      )
    })()
  }

  list(
    vendorId: string,
    productId: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<ProductStaPriceListResponse> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/products/${productId}/sta-price`,
        {
          headers,
          query: queryParams,
        }
      )
    })()
  }

  retrieve(
    id: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<ProductStaPriceDetailResponse> {
    return (async () => {
      const { vendorId, productId, ...reset } = queryParams as any
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/products/${productId}/sta-price/${id}`,
        {
          query: reset,
          headers,
        }
      )
    })()
  }

  delete(
    id: string,
    vendorId: string,
    productId: string,
    headers?: Record<string, unknown>
  ): Promise<unknown> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/products/${productId}/sta-price/${id}`,
        {
          method: "DELETE",
          headers,
        }
      )
    })()
  }

  // batchVariants(productId: string, body: Record<string, any>, query?: Record<string, any>, headers?: Record<string, any>): Promise<any> {
  //   return (async () => {
  //     return await this.client.fetch(`/admin/products/${productId}/variants/batch`, {
  //       method: "POST",
  //       headers,
  //       body,
  //       query,
  //     });
  //   })();
  // }

  // createVariant(productId: string, body: Record<string, any>, query?: Record<string, any>, headers?: Record<string, any>): Promise<any> {
  //   return (async () => {
  //     return await this.client.fetch(`/admin/products/${productId}/variants`, {
  //       method: "POST",
  //       headers,
  //       body,
  //       query,
  //     });
  //   })();
  // }

  // updateVariant(productId: string, id: string, body: Record<string, any>, query?: Record<string, any>, headers?: Record<string, any>): Promise<any> {
  //   return (async () => {
  //     return await this.client.fetch(`/admin/products/${productId}/variants/${id}`, {
  //       method: "POST",
  //       headers,
  //       body,
  //       query,
  //     });
  //   })();
  // }

  // listVariants(productId: string, query?: Record<string, any>, headers?: Record<string, any>): Promise<any> {
  //   return (async () => {
  //     return await this.client.fetch(`/admin/products/${productId}/variants`, {
  //       headers,
  //       query,
  //     });
  //   })();
  // }

  // retrieveVariant(productId: string, id: string, query?: Record<string, any>, headers?: Record<string, any>): Promise<any> {
  //   return (async () => {
  //     return await this.client.fetch(`/admin/products/${productId}/variants/${id}`, {
  //       query,
  //       headers,
  //     });
  //   })();
  // }

  // deleteVariant(productId: string, id: string, headers?: Record<string, any>): Promise<any> {
  //   return (async () => {
  //     return await this.client.fetch(`/admin/products/${productId}/variants/${id}`, {
  //       method: "DELETE",
  //       headers,
  //     });
  //   })();
  // }

  // batchVariantInventoryItems(productId: string, body: Record<string, any>, query?: Record<string, any>, headers?: Record<string, any>): Promise<any> {
  //   return (async () => {
  //     return await this.client.fetch(`/admin/products/${productId}/variants/inventory-items/batch`, {
  //       method: "POST",
  //       headers,
  //       body,
  //       query,
  //     });
  //   })();
  // }

  // createOption(productId: string, body: Record<string, any>, query?: Record<string, any>, headers?: Record<string, any>): Promise<any> {
  //   return (async () => {
  //     return await this.client.fetch(`/admin/products/${productId}/options`, {
  //       method: "POST",
  //       headers,
  //       body,
  //       query,
  //     });
  //   })();
  // }

  // updateOption(productId: string, id: string, body: Record<string, any>, query?: Record<string, any>, headers?: Record<string, any>): Promise<any> {
  //   return (async () => {
  //     return await this.client.fetch(`/admin/products/${productId}/options/${id}`, {
  //       method: "POST",
  //       headers,
  //       body,
  //       query,
  //     });
  //   })();
  // }

  // listOptions(productId: string, query?: Record<string, any>, headers?: Record<string, any>): Promise<any> {
  //   return (async () => {
  //     return await this.client.fetch(`/admin/products/${productId}/options`, {
  //       headers,
  //       query,
  //     });
  //   })();
  // }

  // retrieveOption(productId: string, id: string, query?: Record<string, any>, headers?: Record<string, any>): Promise<any> {
  //   return (async () => {
  //     return await this.client.fetch(`/admin/products/${productId}/options/${id}`, {
  //       query,
  //       headers,
  //     });
  //   })();
  // }

  // deleteOption(productId: string, id: string, headers?: Record<string, any>): Promise<any> {
  //   return (async () => {
  //     return await this.client.fetch(`/admin/products/${productId}/options/${id}`, {
  //       method: "DELETE",
  //       headers,
  //     });
  //   })();
  // }
}
